var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-ht" },
    [
      _c(
        "nav",
        {
          staticClass: "main-header",
          class: {
            "theme-admin": [5, 7, 11].includes(_vm.roleId),
            disable: !_vm.$parent.online,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "mobileHeader",
              class: { displayBlock: _vm.displaySide },
            },
            [
              _c("div", { staticClass: "media-sidebar" }, [
                _c(
                  "div",
                  { staticClass: "page-description txt-alg-rt mr-tp-10" },
                  [
                    _c("span", { staticClass: "company-title" }, [
                      _vm._v(_vm._s(_vm.userCompany)),
                    ]),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "left", trigger: "click" },
                        on: {
                          show: function ($event) {
                            _vm.infoActive = true
                          },
                          hide: function ($event) {
                            _vm.infoActive = false
                          },
                        },
                      },
                      [
                        !_vm.infoActive
                          ? _c("img", {
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_white_icon.svg",
                                alt: "info-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                        _vm.infoActive
                          ? _c("img", {
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_white_icon_active.svg",
                                alt: "infoactive-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                        _c("div", { staticClass: "content" }, [
                          _vm._v("RAMS ID : " + _vm._s(_vm.account_id)),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "mobile-user-info txt-alg-rt mr-tp-10" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "userProfileDropDownMobile collapsed parentCollapse",
                        attrs: {
                          id: "userProfileSettings",
                          href: "#settingsDropDown",
                          "data-toggle": "collapse",
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.profileName) + " "),
                        _c("img", {
                          staticClass: "downCarret mr-lt-4",
                          attrs: {
                            src: "/static/images/icons/chevron_up_white.svg",
                            alt: "chevron-up-icon",
                          },
                        }),
                        _c("img", {
                          staticClass: "upCarret mr-lt-4",
                          attrs: {
                            src: "/static/images/icons/chevron_up_white.svg",
                            alt: "chevron-active-icon",
                          },
                        }),
                      ]
                    ),
                    !_vm.loggedInInitialsFlag
                      ? _c("img", {
                          staticClass: "profilePicMobile",
                          attrs: { src: _vm.imageData, alt: "profile-icon" },
                        })
                      : _vm._e(),
                    _vm.loggedInInitialsFlag
                      ? _c(
                          "span",
                          { staticClass: "profilePicMobile profilePicTitle" },
                          [_vm._v(_vm._s(_vm.loggedInInitials))]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "logo_wrapper" },
            [
              _c(
                "span",
                {
                  staticClass: "burger-toggle",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("mobilesidebar")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "28",
                        height: "20",
                        viewBox: "0 0 28 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("line", {
                        attrs: {
                          x1: "1",
                          y1: "1",
                          x2: "27",
                          y2: "1",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                        },
                      }),
                      _c("line", {
                        attrs: {
                          x1: "1",
                          y1: "10",
                          x2: "27",
                          y2: "10",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                        },
                      }),
                      _c("line", {
                        attrs: {
                          x1: "1",
                          y1: "19",
                          x2: "27",
                          y2: "19",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _c("router-link", { attrs: { to: "/layout/dashboard" } }, [
                _c("img", {
                  staticClass: "img-responsive",
                  attrs: {
                    src: "/static/images/logos/RAMS_logo.png",
                    alt: "rams-logo",
                  },
                }),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "body-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "col-lg-8 col-md-7 col-sm-6",
                staticStyle: { "padding-left": "0px" },
              },
              [
                _vm._m(0),
                _c("div", { staticClass: "col-md-11 col-sm-11" }, [
                  _c(
                    "div",
                    { staticClass: "page-description pd-lt-20" },
                    [
                      _c("span", { staticClass: "company-title" }, [
                        _vm._v(_vm._s(_vm.userCompany)),
                      ]),
                      _c(
                        "el-popover",
                        {
                          attrs: { placement: "bottom", trigger: "click" },
                          on: {
                            show: function ($event) {
                              _vm.infoActive = true
                            },
                            hide: function ($event) {
                              _vm.infoActive = false
                            },
                          },
                        },
                        [
                          !_vm.infoActive
                            ? _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_white_icon.svg",
                                  alt: "info-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _vm.infoActive
                            ? _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_white_icon_active.svg",
                                  alt: "infoactive-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "content" }, [
                            _vm._v("RAMS ID : " + _vm._s(_vm.account_id)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "page-subheading pd-lt-20" }, [
                    _vm._v(" " + _vm._s(_vm.activeMenuTitle)),
                    _vm.activeMenuTitle == "Dashboard" &&
                    _vm.isDashboardCustomizable &&
                    ![4, 10, 11, 12, 13, 14, 15].includes(_vm.roleId)
                      ? _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openPopup("dashboard")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-pencil-square-o edit-icon",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-lg-4 col-md-5 col-sm-6" },
              [
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isClicked,
                          expression: "isClicked",
                        },
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.hideSearchList,
                          expression: "hideSearchList",
                        },
                      ],
                      staticClass: "global-search-container",
                      class: {
                        "admin-search": [5, 7, 11].includes(_vm.roleId),
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "global-search-box-container" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.globalSearchKeyword,
                                expression: "globalSearchKeyword",
                                modifiers: { trim: true },
                              },
                            ],
                            ref: "globalSearchInputBox",
                            staticClass: "global-search-input",
                            class: {
                              "search-list":
                                _vm.isSearchListFetched &&
                                _vm.showAutoSuggestions,
                            },
                            attrs: {
                              type: "text",
                              id: "globalInputBox",
                              autocomplete: "off",
                            },
                            domProps: { value: _vm.globalSearchKeyword },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.getListForSearch.apply(
                                  null,
                                  arguments
                                )
                              },
                              focus: function ($event) {
                                _vm.showAutoSuggestions = true
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.globalSearchKeyword =
                                  $event.target.value.trim()
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _c("div", [
                            _vm.loadServices
                              ? _c("span", { staticClass: "search-loader" })
                              : _vm.globalSearchKeyword.length
                              ? _c("img", {
                                  staticClass: "cursor-pointer search-reset",
                                  attrs: {
                                    src: "/static/images/icons/danger_search_close_icon.svg",
                                    alt: "close-icon",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.setGlobalSearchOptions()
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("p", { staticClass: "vertical-line" }),
                            !_vm.loadServices
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "search-icon cursor-pointer",
                                    class: {
                                      "events-none":
                                        _vm.globalSearchKeyword.length < 3,
                                    },
                                    on: { click: _vm.getListForSearch },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/static/images/icons/new_search.svg",
                                        alt: "search-icon",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _vm.isSearchListFetched && _vm.showAutoSuggestions
                        ? _c(
                            "div",
                            { staticClass: "global-search-list" },
                            [
                              _vm.globalSearchInfo.total_search_result_count
                                ? [
                                    _c(
                                      "ul",
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass: "cursor-pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navigateToDetails(
                                                  "all"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex col-gap-20 justify-space-between",
                                              },
                                              [
                                                _c("div", [_vm._v("All")]),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.globalSearchInfo
                                                          .total_search_result_count
                                                      ) +
                                                      " results "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.filteredServices,
                                          function (service) {
                                            return _c(
                                              "li",
                                              {
                                                key: service.service_name,
                                                staticClass: "cursor-pointer",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.navigateToDetails(
                                                      service.service_name
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex col-gap-20 justify-space-between",
                                                  },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          service.service_name
                                                        )
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          service.result_count
                                                        ) + " results"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                : !_vm.globalSearchInfo
                                    .total_search_result_count &&
                                  _vm.isSearchListFetched
                                ? [
                                    _c("div", { staticClass: "mb-10" }, [
                                      _vm._v(
                                        ' No result found for the search "' +
                                          _vm._s(_vm.selectedSearchOption) +
                                          '" '
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                ![5, 7, 11].includes(_vm.roleId)
                  ? _c(
                      "div",
                      { staticClass: "section-1 mb-10" },
                      [
                        [
                          _vm.roleId !== 4
                            ? [
                                !_vm.isClicked
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "cursor-pointer",
                                        on: {
                                          click: function ($event) {
                                            _vm.isClicked = !_vm.isClicked
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: "/static/images/icons/search_icon_white.svg",
                                            alt: "search-icon",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          ![10, 4, 12, 13, 14, 15].includes(_vm.roleId)
                            ? _c("span", { on: { click: _vm.comment } }, [
                                _c("img", {
                                  staticClass: "comment-icon cursor-pointer",
                                  attrs: {
                                    src: "/static/images/icons/comment_icon_white.svg",
                                    alt: "comment-icon",
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _c("span", { on: { click: _vm.help } }, [
                            _c("img", {
                              staticClass: "help-icon cursor-pointer",
                              attrs: {
                                src: "/static/images/icons/help_icon_white.svg",
                                alt: "help-icon",
                              },
                            }),
                          ]),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
                _c("div", { staticClass: "section-2 help-support" }, [
                  _c("div", { staticClass: "section-support-info" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "pd-lt-0",
                        class: { "mt-7": [5, 7, 11].includes(_vm.roleId) },
                      },
                      [
                        _c("li", { staticClass: "userProfileDropDown" }, [
                          _vm._v(" " + _vm._s(_vm.profileName) + " "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown dropdown-export openOnHover mr-lt-4",
                            },
                            [
                              _c("div", {
                                staticClass: "dropdown-toggle upanddown-arrow",
                                attrs: {
                                  id: "menu0",
                                  "data-toggle": "dropdown",
                                },
                              }),
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right dropdown-settings notify",
                                },
                                [
                                  ![10, 12, 13, 14, 15].includes(_vm.roleId)
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPopup("profile")
                                            },
                                          },
                                        },
                                        [_vm._m(1)]
                                      )
                                    : _vm._e(),
                                  (_vm.roleId === 13 &&
                                    _vm.account_type_id === 2) ||
                                  ![4, 10, 12, 13, 14, 15].includes(_vm.roleId)
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPopup(
                                                _vm.roleId === 13
                                                  ? "team"
                                                  : "notifications"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._m(2)]
                                      )
                                    : _vm._e(),
                                  _vm.accountsList.length > 0
                                    ? _c(
                                        "li",
                                        { on: { click: _vm.switchAccounts } },
                                        [_vm._m(3)]
                                      )
                                    : _vm._e(),
                                  ![4, 7, 10, 12, 13, 14, 15].includes(
                                    _vm.roleId
                                  )
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPopup("tour")
                                            },
                                          },
                                        },
                                        [_vm._m(4)]
                                      )
                                    : _vm._e(),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "flex",
                                        on: { click: _vm.logout },
                                      },
                                      [_vm._m(5), _vm._m(6)]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        !_vm.loggedInInitialsFlag
                          ? _c("li", {
                              staticClass: "profile-pic avatar-background",
                              style: {
                                backgroundImage: "url(" + _vm.imageData + ")",
                              },
                            })
                          : _vm._e(),
                        _vm.loggedInInitialsFlag
                          ? _c(
                              "li",
                              { staticClass: "profile-pic profile-pic-title" },
                              [_vm._v(" " + _vm._s(_vm.loggedInInitials) + " ")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  [5, 7, 11].includes(_vm.roleId)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "section-support-info d-flex justify-content-end col-gap-20",
                        },
                        [
                          [
                            !_vm.isClicked
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "cursor-pointer",
                                    on: { click: _vm.openGlobalSearchBox },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/static/images/icons/search_icon_white.svg",
                                        alt: "search-icon",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          _vm._m(7),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ],
              2
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "mobileProfileSettings collapse",
          attrs: { id: "settingsDropDown" },
        },
        [
          ![10, 12, 13, 14, 15].includes(_vm.roleId)
            ? _c(
                "div",
                {
                  staticClass:
                    "mobileProfileSettingsDropDown border-bottom-property",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.openPopup("profile")
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "img-size",
                        attrs: {
                          src: "/static/images/icons/profile_icon.svg",
                          alt: "profile-icon",
                        },
                      }),
                      _c("span", { staticClass: "mobilePrfSettingsTxt" }, [
                        _vm._v("Profile"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          (_vm.roleId === 13 && _vm.account_type_id === 2) ||
          ![4, 10, 12, 13, 14, 15].includes(_vm.roleId)
            ? _c(
                "div",
                {
                  staticClass:
                    "mobileProfileSettingsDropDown border-bottom-property",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.openPopup(
                            _vm.roleId === 13 ? "team" : "notifications"
                          )
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "img-size",
                        attrs: {
                          src: "/static/images/icons/settings_icon.svg",
                          alt: "settings-icon",
                        },
                      }),
                      _c("span", { staticClass: "mobilePrfSettingsTxt" }, [
                        _vm._v("Account Settings"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm.accountsList.length > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "mobileProfileSettingsDropDown border-bottom-property",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "cursor-pointer",
                      on: { click: _vm.switchAccounts },
                    },
                    [
                      _c("img", {
                        staticClass: "img-size",
                        attrs: {
                          src: "/static/images/icons/switch_account.svg",
                          alt: "switch-icon",
                        },
                      }),
                      _c("span", { staticClass: "mobilePrfSettingsTxt" }, [
                        _vm._v("Choose Accounts"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          ![4, 7, 10, 11, 12, 13, 14, 15].includes(_vm.roleId)
            ? _c(
                "div",
                {
                  staticClass:
                    "mobileProfileSettingsDropDown border-bottom-property hide-xs",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.openPopup("tour")
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "img-size",
                        attrs: {
                          src: "/static/images/icons/virtual_tour_icon.svg",
                          alt: "virtualtour-icon",
                        },
                      }),
                      _c("span", { staticClass: "mobilePrfSettingsTxt" }, [
                        _vm._v("Virtual Tour"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          ![5, 7, 11].includes(_vm.roleId)
            ? [
                ![4, 10, 12, 13, 14, 15].includes(_vm.roleId)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mobileProfileSettingsDropDown border-bottom-property",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "cursor-pointer",
                            on: { click: _vm.comment },
                          },
                          [
                            _c("img", {
                              staticClass: "img-size",
                              attrs: {
                                src: "/static/images/icons/comment_icon.svg",
                                alt: "comment-icon",
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "mobilePrfSettingsTxt" },
                              [_vm._v("Contact Us")]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.roleId !== 5
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mobileProfileSettingsDropDown border-bottom-property",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "cursor-pointer",
                            on: { click: _vm.help },
                          },
                          [
                            _c("img", {
                              staticClass: "img-size",
                              attrs: {
                                src: "/static/images/icons/help_icon.svg",
                                alt: "help-icon",
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "mobilePrfSettingsTxt" },
                              [_vm._v("Help")]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _c("div", { staticClass: "mobileProfileSettingsDropDown" }, [
            _c(
              "span",
              { staticClass: "cursor-pointer", on: { click: _vm.logout } },
              [
                _c("img", {
                  staticClass: "img-size",
                  attrs: {
                    src: "/static/images/icons/logout_icon.svg",
                    alt: "logout-icon",
                  },
                }),
                _c("span", { staticClass: "mobilePrfSettingsTxt" }, [
                  _vm._v("Logout"),
                ]),
              ]
            ),
          ]),
        ],
        2
      ),
      _c("base-popup", {
        attrs: {
          regWatchprefTab: _vm.regWatchprefTab,
          userAction: _vm.userAction,
          account_id: _vm.account_id,
          roleId: _vm.roleId,
        },
        on: { popUpClosed: _vm.popUpClosed, logoutUser: _vm.logoutUser },
      }),
      _c("switch-account-modal", {
        attrs: { chooseaccountsList: _vm.accountsList },
      }),
      _c("feedback-popup"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-1 col-sm-1 separator-line" }, [
      _c("img", {
        attrs: { src: "/static/images/logos/line.png", alt: "line-png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "flex" }, [
      _c("div", { staticClass: "inline-flex" }, [
        _c("img", {
          staticClass: "img-size",
          attrs: {
            src: "/static/images/icons/profile_icon.svg",
            alt: "profile-icon",
          },
        }),
      ]),
      _c("div", { staticClass: "settings-title" }, [
        _c("div", { staticClass: "li-title" }, [_vm._v("Profile")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "flex" }, [
      _c("div", { staticClass: "inline-flex" }, [
        _c("img", {
          staticClass: "img-size",
          attrs: {
            src: "/static/images/icons/settings_icon.svg",
            alt: "settings-icon",
          },
        }),
      ]),
      _c("div", { staticClass: "settings-title" }, [
        _c("div", { staticClass: "li-title" }, [_vm._v("Account Settings")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "flex" }, [
      _c("div", { staticClass: "inline-flex" }, [
        _c("img", {
          staticClass: "img-size",
          attrs: {
            src: "/static/images/icons/switch_account.svg",
            alt: "switch-icon",
          },
        }),
      ]),
      _c("div", { staticClass: "settings-title" }, [
        _c("div", { staticClass: "li-title" }, [_vm._v("Choose Accounts")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "flex" }, [
      _c("div", { staticClass: "inline-flex" }, [
        _c("img", {
          staticClass: "img-size",
          attrs: {
            src: "/static/images/icons/virtual_tour_icon.svg",
            alt: "virtualtour-icon",
          },
        }),
      ]),
      _c("div", { staticClass: "settings-title" }, [
        _c("div", { staticClass: "li-title" }, [_vm._v("Virtual Tour")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inline-flex" }, [
      _c("img", {
        staticClass: "img-size",
        attrs: {
          src: "/static/images/icons/logout_icon.svg",
          alt: "logout-icon",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "settings-title" }, [
      _c("div", { staticClass: "li-title" }, [_vm._v("Logout")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "admin-title" }, [
      _c("li", { staticClass: "admin-circle" }),
      _c("li", [_vm._v("Admin")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }